import apiClient from './api';
import type { OperationTypesConfigResponse } from '../types/activityType';

export const operationTypeService = {
  /**
   * Get operation types configuration from backend
   */
  getOperationTypesConfig: async (): Promise<OperationTypesConfigResponse> => {
    const response = await apiClient.get<OperationTypesConfigResponse>('/operation-types');
    return response.data;
  },
};
